// extracted by mini-css-extract-plugin
module.exports = {"container":"re","content":"rf","title":"rg","mb60":"rh","listItem":"ri","listItemText":"rj","goBack":"rk","goBackText":"rl","header":"rm","closeBtn":"rn","subcategoryBtn":"ro"};